// extracted by mini-css-extract-plugin
export default {"p_tye":"_35fdaaa8ad","slcted":"_5b6e283ae6","slc_color":"e9042aa06c","item_p":"_9b46953b86","r0":"ba24e768e7"};